/**
 * Tabelas do painel.
 *
 * Recebem linhas já formatadas por `leitura.js` — string entra, string aparece.
 * Nenhuma delas ordena, filtra ou soma: a ordem veio do BFF, que a decidiu com
 * a medida certa (consumo diário, não saldo), e reordenar aqui criaria duas
 * verdades no dia em que a lista for paginada.
 */

export type LinhaCritica = {
  codigo: string; descricao: string; filial: string; faixa: string;
  urgencia: string; saldo: string; consumo: string; cobertura: string;
};

export type LinhaExcesso = {
  codigo: string; descricao: string; filial: string; saldo: string; valor: string;
};

export type LinhaFamilia = {
  familia: string; faturamento: string; margem: string; tom: string;
};

export function TabelaCriticos({ linhas }: { linhas: LinhaCritica[] }) {
  return (
    <table className="tabela">
      <caption className="sr">Itens em ruptura ou com cobertura crítica, do maior consumo para o menor</caption>
      <thead>
        <tr>
          <th scope="col">Produto</th>
          <th scope="col">Filial</th>
          <th scope="col" className="num">Saldo</th>
          <th scope="col" className="num">Consumo/dia</th>
          <th scope="col" className="num">Cobertura</th>
        </tr>
      </thead>
      <tbody>
        {linhas.map((l) => (
          <tr key={`${l.codigo}|${l.filial}`}>
            <td>
              <span className={`selo tom-${l.urgencia}`}>{l.faixa}</span>
              <span className="codigo">{l.codigo}</span>
              <span className="descricao">{l.descricao}</span>
            </td>
            <td>{l.filial}</td>
            <td className="num">{l.saldo}</td>
            <td className="num forte">{l.consumo}</td>
            <td className="num">{l.cobertura}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export function TabelaExcesso({ linhas }: { linhas: LinhaExcesso[] }) {
  return (
    <table className="tabela">
      <caption className="sr">Itens sem consumo ou com excesso, do maior valor parado para o menor</caption>
      <thead>
        <tr>
          <th scope="col">Produto</th>
          <th scope="col">Filial</th>
          <th scope="col" className="num">Saldo</th>
          <th scope="col" className="num">Valor parado</th>
        </tr>
      </thead>
      <tbody>
        {linhas.map((l) => (
          <tr key={`${l.codigo}|${l.filial}`}>
            <td>
              <span className="codigo">{l.codigo}</span>
              <span className="descricao">{l.descricao}</span>
            </td>
            <td>{l.filial}</td>
            <td className="num">{l.saldo}</td>
            <td className="num forte">{l.valor}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export function TabelaFamilias({ linhas }: { linhas: LinhaFamilia[] }) {
  return (
    <table className="tabela">
      <caption className="sr">Faturamento e margem por família de produto</caption>
      <thead>
        <tr>
          <th scope="col">Família</th>
          <th scope="col" className="num">Faturamento</th>
          <th scope="col" className="num">Margem</th>
        </tr>
      </thead>
      <tbody>
        {linhas.map((l) => (
          <tr key={l.familia}>
            <td>{l.familia}</td>
            <td className="num">{l.faturamento}</td>
            <td className={`num forte tom-texto-${l.tom}`}>{l.margem}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
